import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
  Grid,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";
import SthanickLogo from "../../assets/images/Home_page_image/Login/LoginLogo.png";
import PlayLogo from "../../assets/images/Home_page_image/Login/Play.png";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import {
  getCustomerId,
  getUserLoginNumber,
} from "../../store/actions/userActions";
import { useDispatch } from "react-redux";
// Styled components for the original UI
const GradientBox = styled(Box)({
  display: "flex",
  width: "100%",
  maxWidth: "100vw",
  minHeight: "100vh",
  height: "auto",
  padding: "16px",
  boxSizing: "border-box",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(to bottom right, #2986cc, #4ea8de, #f97300)",
  overflowX: "hidden",
});

const Card = styled(Box)({
  display: "flex",
  width: "100%",
  maxWidth: "850px",
  backdropFilter: "blur(12px)",
  background: "rgba(255, 255, 255, 0.1)",
  borderRadius: "20px",
  overflow: "hidden",
  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
  "@media (max-width: 1023px)": {
    flexDirection: "column",
    maxWidth: "95vw",
  },
});

const LeftSection = styled(Box)({
  flex: 1,
  padding: "40px",
  background: "#4A0072",
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

const RightSection = styled(Box)({
  flex: 1,
  padding: "30px",
  background: "rgba(255, 255, 255, 0.2)",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

const StyledButton = styled(Button)({
  background: "linear-gradient(to right, #ff416c, #ff4b2b)",
  color: "#fff",
  padding: "12px 0",
  fontSize: "16px",
  fontWeight: "bold",
  borderRadius: "30px",
  marginTop: "20px",
  textTransform: "none",
  ":hover": {
    background: "linear-gradient(to right, #F4511E, #E64A19)",
  },
});

// Styled components for the mobile UI
const MobileGradientBox = styled(Box)({
  display: "flex",
  // width: "100%",
  height: "100vh",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(to bottom right, #2986cc, #4ea8de, #f97300)",
  // padding: "20px",
});

const MobileCard = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "80%",
  maxWidth: "400px",
  backdropFilter: "blur(12px)",
  background: "rgba(255, 255, 255, 0.1)",
  borderRadius: "20px",
  overflow: "hidden",
  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
  padding: "20px",
  textAlign: "center",
});

const Login = () => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpResponse, setOtpResponse] = useState("");
  const [timer, setTimer] = useState(60);
  const inputRefs = useRef([]);
  console.log("isSmallScreen:", isSmallScreen);
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [allowResend, setAllowResend] = useState(false);
  const apptoken = useSelector((state) => state.user.apptoken);
  const dispatch = useDispatch();
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success",
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const {
    data: createRegisterData,
    isLoading: createRegisterLoading,
    error: createRegisterError,
    fetchData: fetchCreateRegisterData,
  } = useFetch(BASE_URL_TEST + urls("userregister"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: verifyOtpData,
    error: verifyOtpError,
    isLoading: verifyOtpDataLoading,
    fetchData: fetchVerifyOtp,
  } = useFetch(BASE_URL_TEST + urls("verifyotp"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: createLoginData,
    isLoading: createLoginLoading,
    error: createLoginError,
    fetchData: fetchCreateLoginData,
  } = useFetch(BASE_URL_TEST + urls("login"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (createRegisterError) {
    } else if (createRegisterData && createRegisterData["status"] === true) {
      const otpFromResponse = createRegisterData?.data?.otp;
      console.log("createRegisterData", createRegisterData?.data);
      setSnackbarState({
        ...snackbarState,
        message: createRegisterData["message"],
        status: createRegisterData["status"],
      });
      console.log("Received OTP:", otpFromResponse);

      if (otpFromResponse && otpFromResponse.length === 6) {
        setOtp(otpFromResponse.split("")); //for otp automatically setting
        //setOtpResponse(otpFromResponse.split(""));
      }
      setShowOTP(true);
    } else if (createRegisterData && createRegisterData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createRegisterData["message"],
        status: createRegisterData["status"],
      });
    }
  }, [createRegisterData, createRegisterError]);

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("").trim();
    if (otp.some((digit) => digit.trim() === "")) {
      setOtpError("OTP is required");
    } else {
      console.log("OTP entered:", otp.join(""));
      setOtpError("");
    }
    const otpRegex = /^\d{6}$/;
    if (!otpRegex.test(enteredOtp)) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }
    setOtpError("");

    const requestData = {
      phone_number: mobileNumber,
      otp: enteredOtp,
      device_type: "web",
    };

    try {
      await fetchVerifyOtp(requestData);
    } catch (error) {
      console.error("OTP verification failed:", error);
      setOtpError("Something went wrong. Please try again.");
    }
  };

  // useEffect(() => {
  //   if (verifyOtpError) {
  //     setSnackbarState({
  //       ...snackbarState,
  //       message: "Something went wrong while verifying OTP.",
  //       status: false,
  //     });
  //   } else if (verifyOtpData && verifyOtpData["status"] === true) {
  //     setSnackbarState({
  //       ...snackbarState,
  //       message: verifyOtpData["message"],
  //       status: verifyOtpData["status"],
  //     });

  //     console.log("OTP verification successful. ID:", verifyOtpData?.data?.id);

  //     navigate("/");
  //   } else if (verifyOtpData && verifyOtpData["status"] === false) {
  //     setSnackbarState({
  //       ...snackbarState,
  //       message: verifyOtpData["message"],
  //       status: verifyOtpData["status"],
  //     });
  //   }
  // }, [verifyOtpData, verifyOtpError]);

  useEffect(() => {
    if (verifyOtpError) {
      setOtpError("Something went wrong while verifying OTP.");
    } else if (verifyOtpData && verifyOtpData["status"] === true) {
      console.log("OTP verification successful. ID:", verifyOtpData?.data);
      dispatch(getCustomerId(verifyOtpData?.data?.id));
      dispatch(getUserLoginNumber({ mobile_number: mobileNumber }));
      console.log("Customer ID dispatched:", mobileNumber);
      navigate("/");
    } else if (verifyOtpData && verifyOtpData["status"] === false) {
      setOtpError(verifyOtpData["message"]);
    }
  }, [verifyOtpData, verifyOtpError]);

  useEffect(() => {
    if (showOTP && timer > 0) {
      const countdown = setTimeout(
        () => setTimer((prevTimer) => prevTimer - 1),
        1000,
      );
      return () => clearTimeout(countdown);
    } else if (timer === 0) {
      setAllowResend(true);
    }
  }, [showOTP, timer]);

  const handleLogin = () => {
    const trimmedMobile = mobileNumber.trim();
    const regex = /^[6-9]\d{9}$/;

    if (!trimmedMobile) {
      setError("Mobile number is required.");
      return;
    } else if (!regex.test(trimmedMobile)) {
      setError("Enter a valid 10-digit mobile number");
      return;
    }
    const saveBody = {
      phone_number: mobileNumber,
      device_type: "web",
      firebase_device_token: "",
    };
    fetchCreateRegisterData(saveBody);
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const resendOtp = () => {
    setOtp(["", "", "", "", "", ""]);
    setTimer(60);
    setAllowResend(false);

    setOtpError("");
    inputRefs.current[0].focus();
    const saveBody = {
      phone_number: mobileNumber,
    };
    fetchCreateRegisterData(saveBody);
  };

  const goToTermsConditions = () => {
    navigate("/termsconditions");
  };

  const goToPrivacyPolicy = () => {
    navigate("/privacy-policy");
  };

  // Original UI for larger screens
  const renderOriginalUI = () => (
    <GradientBox>
      <Card>
        <LeftSection>
          {!showOTP ? (
            <>
              {/* <Typography variant="h4" fontWeight="bold" color="#FF7043">
                Sthanick
              </Typography> */}
              <Box
                component="img"
                src="/Sthanick.jpeg"
                alt="Sthanick"
                sx={{
                  height: 40,
                  width: "auto",
                }}
              />
              <Typography variant="h5" mt={2} textAlign="center">
                Groceries delivered in 10 minutes
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="+91 92****21"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                sx={{ background: "#f8f9fa", borderRadius: "8px" }}
              />
              {error && (
                <Typography
                  color="error"
                  fontSize="10"
                  mt={1}
                  alignSelf={"flex-start"}
                >
                  {error}
                </Typography>
              )}
              <StyledButton fullWidth onClick={handleLogin}>
                Continue
              </StyledButton>
              <Typography variant="caption" mt={2} display="block">
                By continuing, you agree to our{" "}
                <Link
                  component="button"
                  type="button"
                  onClick={goToTermsConditions}
                  underline="hover"
                  color="inherit"
                  sx={{ fontSize: "inherit", verticalAlign: "baseline" }}
                >
                  Terms of Service
                </Link>{" "}
                &{" "}
                <Link
                  component="button"
                  type="button"
                  onClick={goToPrivacyPolicy}
                  underline="hover"
                  color="inherit"
                  sx={{ fontSize: "inherit", verticalAlign: "baseline" }}
                >
                  Privacy Policy
                </Link>
              </Typography>
            </>
          ) : (
            <>
              <IconButton
                onClick={() => setShowOTP(false)}
                sx={{ alignSelf: "flex-start", color: "white" }}
              >
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h4" fontWeight="bold">
                OTP Verification
              </Typography>
              <Typography>
                OTP has been sent to <b>{mobileNumber}</b>
              </Typography>
              <Box mt={3} display="flex" gap={1}>
                {otp.map((digit, index) => (
                  <TextField
                    key={index}
                    value={digit}
                    inputRef={(el) => (inputRefs.current[index] = el)}
                    variant="outlined"
                    sx={{ width: 50, background: "white", borderRadius: "8px" }}
                    inputProps={{
                      maxLength: 1,
                      style: { textAlign: "center" },
                    }}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                  />
                ))}
              </Box>
              {otpError && (
                <Box mt={1} alignSelf={"flex-start"}>
                  <Typography color="error" variant="body2">
                    {otpError}
                  </Typography>
                </Box>
              )}
              {!allowResend ? (
                <Typography mt={2} fontSize={20}>
                  00:{timer < 10 ? `0${timer}` : timer}
                </Typography>
              ) : (
                <Link
                  href="#"
                  sx={{ color: "#FF6D91", fontWeight: "bold", mt: 1 }}
                  onClick={resendOtp}
                >
                  Resend OTP
                </Link>
              )}
              <StyledButton
                fullWidth
                onClick={handleVerifyOtp}
                // disabled={otp.some((digit) => !digit)}
              >
                Submit
              </StyledButton>
            </>
          )}
        </LeftSection>
        <RightSection>
          {/* <img src={SthanickLogo} alt="Sthanic App" width={300} /> */}
          {/* <Typography variant="h4" fontWeight="bold" color="#FF7043">
            Sthanick
          </Typography> */}
          <Box
            component="img"
            src="/Sthanick.jpeg"
            alt="Sthanick"
            sx={{
              height: 40,
              width: "auto",
            }}
          />
          <Typography variant="h6" fontWeight="bold" mt={2}>
            Order faster & easier every time
          </Typography>
          <Typography variant="body2" mt={1}>
            with the Sthanic App
          </Typography>
          <img
            src={PlayLogo}
            alt="Google Play"
            width={180}
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </RightSection>
      </Card>
    </GradientBox>
  );

  // Simplified UI for small screens (mobile)
  const renderMobileUI = () => (
    <MobileGradientBox>
      <MobileCard>
        {!showOTP ? (
          <>
            <Typography variant="h4" fontWeight="bold" color="#FF7043">
              Sthanick
            </Typography>
            <Typography variant="h5" mt={2} textAlign="center">
              Groceries delivered in 10 minutes
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="+91 92****21"
              value={mobileNumber}
              sx={{ background: "#f8f9fa", borderRadius: "8px", mt: 2 }}
              onChange={(e) => setMobileNumber(e.target.value)}
            />
            {error && (
              <Typography
                color="error"
                fontSize="10"
                mt={1}
                alignSelf={"flex-start"}
              >
                {error}
              </Typography>
            )}
            <StyledButton fullWidth onClick={handleLogin}>
              Continue
            </StyledButton>
            <Typography variant="caption" mt={2} display="block">
              By continuing, you agree to our{" "}
              <Link
                component="button"
                type="button"
                onClick={goToTermsConditions}
                underline="hover"
                color="inherit"
                sx={{ fontSize: "inherit", verticalAlign: "baseline" }}
              >
                Terms of Service
              </Link>{" "}
              &{" "}
              <Link
                component="button"
                type="button"
                onClick={goToPrivacyPolicy}
                underline="hover"
                color="inherit"
                sx={{ fontSize: "inherit", verticalAlign: "baseline" }}
              >
                Privacy Policy
              </Link>
            </Typography>
          </>
        ) : (
          <>
            <IconButton
              onClick={() => setShowOTP(false)}
              sx={{ alignSelf: "flex-start", color: "white" }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h4" fontWeight="bold">
              OTP Verification
            </Typography>
            <Typography>
              OTP has been sent to <b>{mobileNumber}</b>
            </Typography>
            <Box mt={3} display="flex" gap={1} p={0}>
              {otp.map((digit, index) => (
                <TextField
                  key={index}
                  inputRef={(el) => (inputRefs.current[index] = el)}
                  variant="outlined"
                  sx={{
                    width: 50,
                    background: "white",
                    borderRadius: "8px",
                    p: 0,
                  }}
                  inputProps={{
                    maxLength: 1,
                    style: { textAlign: "center" },
                  }}
                  value={digit}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </Box>
            {otpError && (
              <Box mt={1} alignSelf={"flex-start"}>
                <Typography color="error" variant="body2">
                  {otpError}
                </Typography>
              </Box>
            )}
            {!allowResend ? (
              <Typography mt={2} fontSize={20}>
                00:{timer < 10 ? `0${timer}` : timer}
              </Typography>
            ) : (
              <Link
                href="#"
                sx={{ color: "#FF6D91", fontWeight: "bold", mt: 1 }}
                onClick={resendOtp}
              >
                Resend OTP
              </Link>
            )}
            <StyledButton
              fullWidth
              onClick={handleVerifyOtp}
              //disabled={otp.some((digit) => !digit)}
            >
              Submit
            </StyledButton>
          </>
        )}
      </MobileCard>
    </MobileGradientBox>
  );

  return isSmallScreen ? renderMobileUI() : renderOriginalUI();
};

export default Login;
